import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MatchingItemMasterCommand, SearchSeveralCommand, Yarn } from '../../models/yarn/yarn-search';
import { ItemMaster } from '../../models/item/item-master/item-master';

import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class YarnSearchProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/yarn';

  postYarnSearch(query: string): Observable<ApiResponse<PaginatedApiResponse<Yarn>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Yarn>>>(`${this.baseUrl}/search`, { longDescription: query });
  }

  getYarnsByIds(ids: string[]): Observable<Yarn[]> {
    return this.httpClient.post<Yarn[]>(`${this.baseUrl}/materialized-batch`, { ids: ids });
  }

  getByArticleCodeAndDataBaseName(command: SearchSeveralCommand): Observable<Yarn[]> {
    return this.httpClient.post<Yarn[]>(`${this.baseUrl}/search-several`, command);
  }

  getItemMastersByYarnCode(command: MatchingItemMasterCommand[]): Observable<ApiResponse<Record<string, ItemMaster | null>>> {
    return this.httpClient.post<ApiResponse<Record<string, ItemMaster | null>>>(`${this.baseUrl}/yarn-code/batch/item-master`, command);
  }
}
